



import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from 'axios';
import logo from '../assets/images/logo.png';
import { Menu, X } from "lucide-react";

const Subscription = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en"); // Default language: English
  const navigate = useNavigate();
  const msisdn = Cookies.get('gameofyy_user');

  useEffect(() => {
    if (msisdn) {
      navigate('/');
    } else {
      axios.get('/getheaders')
        .then(response => {
          const data = response.data;
          if (data.status == '1') {
            Cookies.set('gameofyy_user', data.msisdn, { expires: 1 });
            Cookies.set('status', data.status, { expires: 1 });
            navigate('/');
          }
        })
        .catch(error => console.error("Error fetching data:", error));
    }
  }, [msisdn, navigate]);

  const handleSubscribe = () => {
    window.location.href = "http://consent.hutch.lk/register-service/VA%3D%3DCQ%3D%3Dew%3D%3D";
  };

  // Language Translations
  const translations = {
    en: {
      title: "GAMEOFFY",
      subtitle: "Video Games Online",
      subscribeInfo1: "Subscribe to Gameofyy service",
      subscribeInfo2: "You will be charged Rs. 6+tax/1 apply",
      subscribe: "Subscribe",
      termsTitle: "Terms & Conditions",
      terms: [
        "By clicking on subscribe, you agree to the following terms and conditions.",
        "If you are a new customer, you will have the service free for one day then you will be charged as per selected pack.",
        "Your subscription will be automatically renewed until you cancel or unsubscribe.",
        "You can unsubscribe any time through the site by clicking on 'My Account' then 'Unsubscribe'.",
        "You must be more than 18 years old to use this service.",
        "If you are less than 18 years old, you MUST receive permission from the authorized person who pays your bill.",
        "Standard data browsing costs will be applied.",
        "For support, please contact us at support@nexgen.com"
      ]
    },
    si: {
      title: "GAMEOFFY",
      subtitle: "ගේමින් සේවාව",
      subscribeInfo1: "Gameofyy සේවාවට දායක වන්න",
      subscribeInfo2: "ඔබට Rs. 6+බදු/1 අය වේ",
      subscribe: "සක්‍රිය කරන්න",
      termsTitle: "නියම සහ කොන්දේසි",
      terms: [
        "සබ්ස්ක්‍රයිබ් බොත්තම ක්ලික් කිරීමෙන්, ඔබ පහත නියම සහ කොන්දේසි පිළිගනිමින්.",
        "නව ගනුදෙනුකරුවෙකු ලෙස, ඔබට සේවාව දවසක් නොමිලේ ලබාදෙනු ඇත. එයට පසුව තෝරාගත් පැකේජය අනුව අය කරනු ඇත.",
        "ඔබගේ දායකත්වය ස්වයංක්‍රීයව නැවත ලබාදෙනු ඇත. ඔබ අහෝසි කරන තෙක් එය ක්‍රියාත්මක වේ.",
        "'මගේ ගිණුම' වෙත පිවිසි විට 'අවලංගු කරන්න' ක්ලික් කර ඔබට සේවාව අවලංගු කළ හැක.",
        "මෙම සේවාව භාවිතා කිරීමට අවුරුදු 18 ට වැඩි විය යුතුය.",
        "ඔබගේ වයස අවුරුදු 18 ට අඩු නම්, ඔබගේ ගිණුම් ගෙවීමේ අවසර ලැබිය යුතුය.",
        "සම්මත දත්ත ගවේෂණ ගාස්තු අදාළ වේ.",
        "සහාය සඳහා, කරුණාකර support@nexgen.com වෙත අපව සම්බන්ධ කරගන්න."
      ]
    },
    ta: {
      title: "GAMEOFFY",
      subtitle: "கேமிங் சேவை",
      subscribeInfo1: "Gameofyy சேவைக்கு பதிவு செய்யவும்",
      subscribeInfo2: "உங்களிடம் ரூ. 6+வரி/1 அறவிடப்படும்",
      subscribe: "செயல்படுத்து",
      termsTitle: "விதிமுறைகள் & நிபந்தனைகள்",
      terms: [
        "சப்ஸ்கிரைப் செய்வதன் மூலம், நீங்கள் பின்வரும் விதிமுறைகள் மற்றும் நிபந்தனைகளை ஒப்புக்கொள்கிறீர்கள்.",
        "புதிய வாடிக்கையாளராக இருந்தால், ஒரு நாளைக்கு இலவச சேவை வழங்கப்படும், பின்னர் தேர்ந்தெடுக்கப்பட்ட தொகுப்பின் படி கட்டணமாகும்.",
        "உங்கள் சந்தா தானாகவே புதுப்பிக்கப்படும், நீங்கள் ரத்து செய்யும் வரை இது தொடரும்.",
        "'என் கணக்கு' என்பதற்குச் சென்று 'ரத்து செய்க' என்பதைச் சொடுக்கு மூலம் நீங்கள் எந்த நேரத்திலும் ரத்து செய்யலாம்.",
        "இந்த சேவையைப் பயன்படுத்த 18 வயதுக்கு மேல் இருக்க வேண்டும்.",
        "நீங்கள் 18 வயதுக்கு குறைந்தவர்கள் என்றால், உங்கள் கட்டணம் செலுத்தும் நபரிடமிருந்து அனுமதி பெற வேண்டும்.",
        "தரமான தரவுப் பரிசீலனைக் கட்டணங்கள் பொருந்தும்.",
        "ஆதரவிற்கான தொடர்பு: support@nexgen.com"
      ]
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
    <header className="flex items-center justify-between p-4 bg-gradient-to-r from-green-400 to-yellow-500 shadow-lg">
      <div className="flex items-center space-x-2">
        <img src={logo} alt="Gameoffy Logo" className="h-8 w-auto" />
      </div>
      <div className="flex space-x-2">
        <button className={`px-3 py-1 rounded-lg text-sm font-semibold ${selectedLanguage === 'en' ? 'bg-blue-600 text-white' : 'bg-gray-300 text-black'}`} onClick={() => setSelectedLanguage('en')}>English</button>
        <button className={`px-3 py-1 rounded-lg text-sm font-semibold ${selectedLanguage === 'si' ? 'bg-blue-600 text-white' : 'bg-gray-300 text-black'}`} onClick={() => setSelectedLanguage('si')}>සිංහල</button>
        <button className={`px-3 py-1 rounded-lg text-sm font-semibold ${selectedLanguage === 'ta' ? 'bg-blue-600 text-white' : 'bg-gray-300 text-black'}`} onClick={() => setSelectedLanguage('ta')}>தமிழ்</button>
      </div>

      {/* Menu Button */}
<div className="relative">
  <button
    onClick={() => setMenuOpen(!menuOpen)}
    className="text-white focus:outline-none"
  >
    {menuOpen ? <X size={28} /> : <Menu size={28} />}
  </button>

  {/* Dropdown Menu */}
  {menuOpen && (
    <div
      className="absolute top-12 right-4 bg-white text-black w-48 rounded-lg shadow-lg z-50 transition-all ease-in-out"
      onBlur={() => setMenuOpen(false)}
      tabIndex={0}
    >
      <ul className="py-2">
        <li 
          className="px-4 py-2 cursor-pointer hover:bg-gray-200" 
          onClick={handleSubscribe}
        >
          {translations[selectedLanguage].subscribe}
        </li>
        <li 
          className="px-4 py-2 cursor-pointer hover:bg-gray-200"
          onClick={() => window.location.href = "https://hutch.lk/vterms/"}
        >
          {translations[selectedLanguage].termsTitle}
        </li>
      </ul>
    </div>
  )}
</div>

    </header>
  
    <section className="relative flex flex-col items-center text-center w-full py-10 px-6">
      <h1 className="text-green-300 text-4xl font-bold">{translations[selectedLanguage].title}</h1>
      <h2 className="text-white text-lg">{translations[selectedLanguage].subtitle}</h2>
      <p className="text-gray-200 text-lg font-semibold">{translations[selectedLanguage].subscribeInfo1}</p>
      <p className="text-gray-300 text-md font-semibold">{translations[selectedLanguage].subscribeInfo2}</p>
      <button onClick={handleSubscribe} className="bg-orange-500 text-white px-6 py-3 mt-3 rounded-lg text-lg font-bold shadow-lg hover:bg-orange-600 transition">{translations[selectedLanguage].subscribe}</button>
  
      {/* Terms and Conditions Section */}
      <div className="mt-6 bg-gray-800 p-6 rounded-lg shadow-lg max-w-2xl">
        <h3 className="text-xl font-bold mb-4">{translations[selectedLanguage].termsTitle}</h3>
        <ul className="list-disc text-justify text-gray-300">
          {translations[selectedLanguage].terms.map((term, index) => (
            <li key={index} className="mb-2">{term}</li>
          ))}
        </ul>
      </div>
    </section>
  </div>
  
  );
};

export default Subscription;
